<template>
  <v-layout
    align-center
    justify-center
    row
    fill-height
    class="logging-view"
  >
    <v-dialog
      v-model="dialogHelpGoogleAuthenticatorMobile"
      persistent
      min-width="50%"
      width="550"
    >
      <v-card v-if="dialogHelpGoogleAuthenticatorMobileStep == 1">
        <v-card-text class="headline">
          Aide à l'installation de Google Authenticator pour Pooopl
        </v-card-text>
        <v-card-text>
          <p>Sous quel environement est votre mobile ?</p>
          <v-radio-group
            v-model="dialogHelpGoogleAuthenticatorMobileType"
            :mandatory="false"
          >
            <v-radio
              label="Sous Android (Samsung, Pixel, OnePlus, Sony...)"
              value="android"
            />
            <v-radio
              label="Sous IOS (Iphone) "
              value="ios"
            />
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogHelpGoogleAuthenticatorMobile = false"
          >
            Fermer
          </v-btn>
          <v-btn @click="dialogHelpGoogleAuthenticatorMobileStep = 2">
            Suivante
            <v-icon dark>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="dialogHelpGoogleAuthenticatorMobileStep == 2 && dialogHelpGoogleAuthenticatorMobileType == 'ios'">
        <v-card-text class="headline">
          Aide à l'installation de Google Authenticator sur iOS
        </v-card-text>
        <v-card-text>
          <ul style="list-style: decimal">
            <li>
              Ouvrez l'application <span class="font-weight-medium">Appareil photo</span>
              <v-avatar tile>
                <v-img
                  contain
                  src="/img/iphone-appareil-photo-icone1.png"
                  width="32"
                  height="32"
                />
              </v-avatar>
            </li>
            <li>
              Faites une mise au point sur ce QR Code rouge : <br>
              <qrcode
                :options="{ width: 200, color: { dark: '#AA0000'} }"
                value="https://apps.apple.com/fr/app/google-authenticator/id388497605"
              />
              <br>
              <span class="caption text-gray">(Si vous n'arrivez pas à scanner ce QR Code, lancez l'AppStore et recherchez Google Authenticator puis passez à l'étape 4)</span>
            </li>
            <li>
              Appuyez sur la <span class="font-weight-medium">notification</span> qui s'affiche pour
              lancer l'AppStore
            </li>
            <li>Installez <span class="font-weight-medium">Google Authenticator</span></li>
            <li>
              <span class="font-weight-medium">Lancez Google Authenticator</span> et appuyez sur le bouton
              <v-btn
                color="info"
                icon
              >
                <v-icon small>
                  mdi-plus
                </v-icon>
              </v-btn>
            </li>
            <li>
              Fermer cette boite de dialogue et scannez le <span style="color:#0000AA">QR code bleu</span>
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogHelpGoogleAuthenticatorMobileStep = 1"
          >
            <v-icon dark>
              mdi-chevron-left
            </v-icon>
            Précédent
          </v-btn>
          <v-btn @click="dialogHelpGoogleAuthenticatorMobile = false">
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-if="dialogHelpGoogleAuthenticatorMobileStep == 2 && dialogHelpGoogleAuthenticatorMobileType == 'android'">
        <v-card-text class="headline">
          Aide à l'installation de Google Authenticator sur Android
        </v-card-text>
        <v-card-text>
          <ul style="list-style: decimal">
            <li>Ouvrez une application de QR Code (ou Google Lens)</li>
            <li>
              Scannez ce QR Code rouge : <br>
              <qrcode
                :options="{ width: 200, color: { dark: '#AA0000'} }"
                value="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=fr"
              />
              <br>
              <span class="caption text-gray">(Si vous n'arrivez pas à scanner ce QR Code, lancez le PlayStore et recherchez Google Authenticator puis passez à l'étape 3)</span>
            </li>
            <li>Installez <span class="font-weight-medium">Google Authenticator</span></li>
            <li>
              <span class="font-weight-medium">Lancez Google Authenticator</span> et appuyez sur le bouton
              <v-btn
                color="red"
                icon
                rounded
              >
                <v-icon
                  small
                  color="white"
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </li>
            <li>
              Fermer cette boite de dialogue et scannez le <span style="color:#0000AA">QR code bleu</span>
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="dialogHelpGoogleAuthenticatorMobileStep = 1"
          >
            <v-icon dark>
              mdi-chevron-left
            </v-icon>
            Précédent
          </v-btn>
          <v-btn @click="dialogHelpGoogleAuthenticatorMobile = false">
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogNoGroup"
      persistent
      width="50%"
    >
      <v-card>
        <v-card-text class="headline">
          Problème de configuration
        </v-card-text>
        <v-card-text>
          <p>
            Veuillez contacter votre responsable. <br>
            Votre compte a bien était créé, cependént, aucun groupe n'y est rattaché. <br>
            Par conséquent vous n'avez pas accès à WorkTools.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="$auth.signOut()">
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row
      no-gutters
      align="center"
      justify="center"
    >
      <v-spacer />
      <v-col
        cols="12"
        md="6"
        sm="8"
        xs="12"
      >
        <v-flex
          class=" ma-2
    align-center
    justify-center"
        >
          <v-toolbar
            color="tertiary"
            dark
          >
            <v-spacer />
            <v-toolbar-title class="white--text">
              Connexion à WorkTools
            </v-toolbar-title>
            <v-spacer />
          </v-toolbar>

          <v-card v-if="step === 'loading'">
            <v-layout
              align-center
              justify-center
              row
              fill-height
              pa-6
            >
              <v-progress-circular

                :size="50"
                color="primary"
                indeterminate
              />
            </v-layout>
          </v-card>

          <v-card v-if="step === 'form-login'">
            <v-card-text>
              <v-container
                fluid
                class="ma-0 pa-0"
              >
                <v-row
                  align="center"
                  justify="center"
                  no-gutters
                >
                  <v-col
                    cols="12"
                    sm="2"
                    pt-4
                    align-self="center"
                    align="center"
                  >
                    <v-img
                      src="/img/lock.png"
                      contain
                      max-width="128"
                      class="mb-sm-4"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="10"
                    xs="12"
                  >
                    <v-layout
                      row
                      wrap
                      ml-4
                      mr-4
                    >
                      <v-flex xs12>
                        <div class="headline">
                          Authentification
                        </div>
                      </v-flex>
                      <v-flex
                        xs12
                        class="pr-3"
                      >
                        <v-text-field
                          v-model="email"
                          type="text"
                          label="Email"
                          autofocus
                          @keyup.native.enter="submitLogin"
                        />
                      </v-flex>
                      <v-flex
                        xs12
                        class="pr-3"
                      >
                        <v-text-field
                          v-model="password"
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPassword ? 'text' : 'password'"
                          label="Mot de passe"
                          @click:append="showPassword = !showPassword"
                          @keyup.native.enter="submitLogin"
                        />
                      </v-flex>
                    </v-layout>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-container
                fluid
                class="ma-0 pa-0"
              >
                <v-row
                  align="center"
                  justify="center"
                  no-gutters
                >
                  <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    class="text-center"
                  >
                    <v-hover>
                      <v-btn
                        slot-scope="{ hover }"
                        :class="`elevation-${hover ? 2 : 0}`"
                        :disabled="email == '' || email.split('@').length !== 2"
                        text
                        @click="forgotPassword"
                      >
                        <v-icon left>
                          mdi-lock-question
                        </v-icon>
                        Mot de passe perdu
                      </v-btn>
                    </v-hover>
                  </v-col>

                  <v-col
                    cols="12"
                    xs="12"
                    sm="6"
                    class="text-center"
                  >
                    <v-btn
                      :disabled="loginDesabled"
                      @click="submitLogin"
                    >
                      <v-icon left>
                        mdi-check
                      </v-icon>
                      Connexion
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>

          <v-card v-if="step === 'new-password'">
            <v-card-text>
              <v-layout
                row
                wrap
              >
                <v-flex
                  sm2
                  pt-4
                  align-self-center
                >
                  <v-img
                    src="/img/user.png"
                    contain
                    max-width="128"
                  />
                </v-flex>
                <v-flex
                  sm10
                  xs12
                >
                  <v-layout
                    row
                    wrap
                    ml-4
                    mr-4
                  >
                    <v-flex xs12>
                      <div class="headline">
                        Première connexion
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="firstName"
                        type="text"
                        label="Prénom"
                        autofocus
                        @keyup.native.enter="submitChangePassword"
                      />
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        v-model="lastName"
                        type="text"
                        label="Nom"
                        @keyup.native.enter="submitChangePassword"
                      />
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                        v-model="newPassword"
                        :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showNewPassword ? 'text' : 'password'"
                        label="Nouveau mot de passe"
                        @keyup.native.enter="submitChangePassword"
                        @click:append="showNewPassword = !showNewPassword"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                :disabled="changePasswordDesabled"
                @click="submitChangePassword"
              >
                <v-icon left>
                  mdi-check
                </v-icon>
                Enregistrer
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card v-if="step === 'setup-mfa'">
            <v-card-text>
              <v-layout
                row
                wrap
              >
                <v-flex
                  sm2
                  pt-4
                  align-self-center
                >
                  <v-img
                    src="/img/keys.png"
                    contain
                    max-width="128"
                  />
                </v-flex>
                <v-flex
                  sm10
                  xs12
                >
                  <v-layout
                    row
                    wrap
                    ml-4
                    mr-4
                  >
                    <v-flex xs12>
                      <div class="headline">
                        Sécurisation de votre compte
                      </div>
                      <ul>
                        <li>
                          Installez une application TOTP sur votre mobile : <br><span
                            class="font-weight-black"
                          > Google Authenticator </span><br>
                          <v-hover>
                            <v-btn
                              slot-scope="{ hover }"
                              :class="`elevation-${hover ? 4 : 1}`"
                              small
                              text
                              @click="dialogHelpGoogleAuthenticatorMobile = true; dialogHelpGoogleAuthenticatorMobileStep = 1"
                            >
                              <v-icon
                                left
                                dark
                              >
                                mdi-help
                              </v-icon>
                              Besoin d'aide à l'installation ?
                            </v-btn>
                          </v-hover>
                        </li>
                        <li v-if="!isMobile">
                          Scannez ce QRCode bleu avec votre mobile :<br>
                          <a
                            :href="qrcode"
                            target="_blank"
                          ><qrcode
                            :value="qrcode"
                            :options="{ width: 200, color: { dark: '#0000AA'} }"
                          /></a>
                        </li>
                        <li v-if="isMobile">
                          Associez votre mobile et optennez un code unique : <br>
                          <v-btn
                            target="_blank"
                            :href="qrcode"
                            small
                            text
                            class="elevation-1"
                          >
                            <v-icon left>
                              mdi-link-variant-plus
                            </v-icon> Associer
                          </v-btn>
                        </li>
                        <li>Saissez le code obtenu :</li>
                      </ul>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="mfaCode"
                        type="text"
                        label="Code unique à 6 chiffres"
                        :autofocus="!isMobile"
                        @keyup.native.enter="submitSetupMfa"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                :disabled="invalidMfaCode"
                @click="submitSetupMfa"
              >
                <v-icon left>
                  mdi-check
                </v-icon>
                Valider mon mobile
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card v-if="step === 'mfa'">
            <v-card-text>
              <v-layout
                row
                wrap
              >
                <v-flex
                  sm2
                  pt-4
                  align-self-center
                >
                  <v-img
                    src="/img/keys.png"
                    contain
                    max-width="128"
                  />
                </v-flex>
                <v-flex
                  sm10
                  xs12
                >
                  <v-layout
                    row
                    wrap
                    ml-4
                    class="mr-4"
                  >
                    <v-flex xs12>
                      <div class="headline">
                        Double authentification
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      Saisissez le code présent sur votre mobile.
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="mfaCode"
                        type="text"
                        label="Code unique à 6 chiffres"
                        autofocus
                        @keyup.native.enter="submitMfa"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                :disabled="invalidMfaCode"
                @click="submitMfa"
              >
                <v-icon left>
                  mdi-check
                </v-icon>
                Valider
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card v-if="step === 'forgot-password'">
            <v-card-text>
              <v-layout
                row
                wrap
              >
                <v-flex
                  sm2
                  pt-4
                  align-self-center
                >
                  <v-img
                    src="/img/mail.png"
                    contain
                    max-width="128"
                  />
                </v-flex>
                <v-flex
                  sm10
                  xs12
                >
                  <v-layout
                    row
                    wrap
                    ml-4
                    pr-4
                  >
                    <v-flex xs12>
                      <div class="headline">
                        Mot de passe perdu
                      </div>
                    </v-flex>
                    <v-flex xs12>
                      Un email vient de vous être envoyé contenant un code. Saisissez-le ici puis
                      saisissez votre nouveau mot de passe.
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="mfaCode"
                        type="text"
                        label="Code unique à 6 chiffres"
                        autofocus
                        @keyup.native.enter="submitForgotPassword"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="newPassword"
                        :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showNewPassword ? 'text' : 'password'"
                        label="Nouveau mot de passe"
                        @keyup.native.enter="submitChangePassword"
                        @click:append="showNewPassword = !showNewPassword"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                :disabled="invalidMfaCode"
                @click="submitForgotPassword"
              >
                <v-icon left>
                  mdi-check
                </v-icon>
                Valider
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-col>

      <v-spacer />
    </v-row>
  </v-layout>
</template>

<script>
import { mapMutations } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  components: {
    qrcode: VueQrcode
  },
  data () {
    return {
      dialogNoGroup: false,
      dialogHelpGoogleAuthenticatorMobileType: 'android',
      dialogHelpGoogleAuthenticatorMobileStep: 1,
      dialogHelpGoogleAuthenticatorMobile: false,
      step: 'loading',
      email: '',
      showPassword: false,
      password: '',
      showNewPassword: false,
      newPassword: '',
      firstName: '',
      lastName: '',
      qrcode: '',
      mfaCode: ''
    }
  },
  computed: {
    loginDesabled () {
      if (this.email.trim() === '' || this.password.trim() === '') {
        return true
      }
      if (this.email.split('@').length !== 2) {
        return true
      }
      if (this.password.length < 4) {
        return true
      }
      return false
    },
    changePasswordDesabled () {
      return (this.firstName.trim() === '' || this.lastName.trim() === '')
    },
    invalidMfaCode () {
      if (!this.mfaCode) {
        return true
      }
      let mfaRegex = /^[0-9]{6}$/g
      if (this.mfaCode.match(mfaRegex)) {
        return false
      }
      return true
    },
    isMobile () {
      return !!/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)
    }
  },
  mounted () {
    if (process.env.VUE_APP_DEV_FORCE_LOGIN === 'true') {
      if (this.$route.name === 'user-login' && this.$route.query && this.$route.query.path) {
        return this.$router.replace(this.$route.query.path)
      }
      this.$router.replace('home')
      return
    }

    this.stateLoading()
    // Check if user is connected
    this.$auth.currentAuthenticatedUser({ bypassCache: false })
      .then(() => {
        this.userIsLoggedIn()
      })
      .catch((error) => {
        console.error(error)
        this.goToLoginForm()
      })
  },
  methods: {
    ...mapMutations('app', ['addSnackbar']),
    ...mapMutations('user', ['setDisplayName', 'setFirstName', 'setLastName', 'setEmail', 'setLogged']),
    submitLogin () {
      if (this.loginDesabled) {
        return
      }
      this.stateLoading()

      this.doLogin(this.email, this.password)
      this.password = ''
    },
    error (message) {
      this.addSnackbar({ message: message, color: 'error' })
    },
    stateLoading () {
      this.step = 'loading'
    },
    goToLoginForm () {
      this.step = 'form-login'
    },
    doLogin (username, password) {
      return this.$auth.signIn(username, password)
        .then((user) => {
          this.cognitoUserObject = user
          this.checkChallengeUser()
        })
        .catch(error => {
          if (error.code === 'UserNotFoundException' || error.code === 'NotAuthorizedException') {
            this.goToLoginForm()
            return this.error('Le couple email/mot de passe n\'existe pas.')
          }
          console.error(error)
        })
    },

    userIsLoggedIn () {
      this.stateLoading()
      this.$auth.currentAuthenticatedUser()
        .then((user) => {
          // TODO why listener not receive auth message ?
          this.$store.commit('user/setFirstName', user.attributes.given_name)
          this.$store.commit('user/setLastName', user.attributes.family_name)
          this.$store.commit('user/setDisplayName', user.attributes.given_name + ' ' + user.attributes.family_name)
          this.$store.commit('user/setEmail', user.attributes.email)
          this.$store.commit('user/setCredentials', user.signInUserSession.idToken.payload['permissions'] ? user.signInUserSession.idToken.payload['permissions'].split(',') : [])
          this.$store.commit('user/setLogged', true)

          if (this.$route.name === 'user-login' && this.$route.query && this.$route.query.path) {
            return this.$router.replace(this.$route.query.path)
          }
          this.$router.replace('home')
        })
        .catch((error) => {
          if (error.code === 'group-not-found') {
            this.dialogNoGroup = true
          }
          console.error(error)
          this.goToLoginForm()
        })
    },
    checkChallengeUser () {
      if (!this.cognitoUserObject) {
        return
      }
      let user = this.cognitoUserObject
      if (user.challengeName === 'SMS_MFA' ||
          user.challengeName === 'SOFTWARE_TOKEN_MFA') {
        this.step = 'mfa'
      } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        this.step = 'new-password'
      } else if (user.challengeName === 'MFA_SETUP') {
        this.stateLoading()
        this.$auth.setupTOTP(user)
          .then((code) => {
            this.step = 'setup-mfa'
            let issuer = 'WorkTools' // TODO Put environement here
            this.qrcode = 'otpauth://totp/AWSCognito:' + encodeURIComponent(user.username) + '?secret=' + encodeURIComponent(code) + '&issuer=' + encodeURIComponent(issuer)
          })
          .catch(err => {
            console.error(err)
            this.goToLoginForm()
          })
      } else {
        this.userIsLoggedIn()
      }
    },

    submitSetupMfa () {
      if (this.invalidMfaCode) {
        return
      }
      this.stateLoading()
      this.$auth.verifyTotpToken(this.cognitoUserObject, this.mfaCode)
        .then(() => {
          this.mfaCode = ''

          return this.$auth.setPreferredMFA(this.cognitoUserObject, 'TOTP')
            .then(() => {
              this.userIsLoggedIn()
            })
        }).catch(error => {
          this.step = 'setup-mfa'
          this.mfaCode = ''
          if (error.code === 'EnableSoftwareTokenMFAException') {
            this.error('Le code saisi n\'est pas valide.')
            return
          }
          console.error(error)
        })
    },

    submitChangePassword () {
      if (this.changePasswordDesabled) {
        return
      }
      this.stateLoading()
      this.$auth.completeNewPassword(
        this.cognitoUserObject,
        this.newPassword,
        {
          email: this.email,
          family_name: this.lastName,
          given_name: this.firstName
        }
      ).then(user => {
        this.cognitoUserObject = user
        this.checkChallengeUser()
      }).catch((error) => {
        if (error.code === 'InvalidPasswordException') {
          this.error('Le mot de passe n\'est pas valide.')
          this.step = 'new-password'
          return
        }
        console.error(error)
      })
    },

    submitMfa () {
      if (this.invalidMfaCode) {
        return
      }
      this.stateLoading()
      this.$auth.confirmSignIn(
        this.cognitoUserObject,
        this.mfaCode,
        'SOFTWARE_TOKEN_MFA'
      )
        .then((user) => {
          this.cognitoUserObject = user
          this.userIsLoggedIn(user)
        })
        .catch((error) => {
          this.step = 'mfa'
          if (error.code === 'CodeMismatchException') {
            this.error('Le code saisi n\'est pas valide.')
            return
          }
          console.error(error)
        })
    },

    forgotPassword () {
      this.stateLoading()
      this.newPassword = ''
      this.mfaCode = ''
      this.$auth.forgotPassword(this.email)
        .then(() => {
          this.step = 'forgot-password'
        })
        .catch(error => {
          if (error.code === 'LimitExceededException') {
            this.error('La demande est temporairement désactivé suite à un trop grand nombre de tentative. Recommencez dans quelques minutes')
          }
          if (error.code === 'UserNotFoundException') {
            this.error('Le compte utilisateur n\'existe pas avec cette adresse email. Contacter le service technique')
          }
          console.error(error)
          this.goToLoginForm()
        })
    },

    submitForgotPassword () {
      this.$auth.forgotPasswordSubmit(this.email, this.mfaCode, this.newPassword)
        .then(() => {
          this.stateLoading()
          this.doLogin(this.email, this.newPassword)
          this.newPassword = ''
          this.mfaCode = ''
        })
        .catch(error => {
          if (error.code === 'InvalidPasswordException') {
            this.error('Le mot de passe n\'est pas valide.')
            return
          }
          console.error(error)
        })
    }
  }
}
</script>
<style>
    .logging-view .v-toolbar__content {
        margin-left: 0 !important;
    }
</style>
